import { Bank, PencilSimple } from '@phosphor-icons/react';
import { Chip, ImmoButton, InnenKarte, KartenTitel, LeerZustand } from '../../../../../components/immobilien/ui';
import { deDatum } from '../../../../../lib/immobilien/objektDetail';
import { BUCHHALTUNG_FOLGT } from '../../../../../lib/immobilien/hinweise';
import { kontaktName } from '../../../../../lib/objekte/objektKontakte';
import { useEinheitSeite } from '../EinheitSeitenKontext';
import { DatenZeile, ibanText } from './teile';

/** „Zahlungsweg & SEPA“: Angaben aus dem Mietverhältnis; der Bankabgleich kommt mit der Buchhaltung. */
export function BankBereich() {
  const s = useEinheitSeite();
  if (s.laufende.length === 0) return <LeerZustand icon={Bank} titel="Kein Zahlungsweg" text="Ohne laufendes Mietverhältnis gibt es keinen Zahlungsweg." />;
  return (
    <>
      {s.laufende.map(m => {
        const sepa = m.sepa_aktiv === true;
        return (
          <InnenKarte key={m.id}>
            <KartenTitel icon={Bank} rechts={s.laufende.length > 1 ? kontaktName(m) : undefined}>{sepa ? 'SEPA-Lastschrift' : 'Überweisung durch den Mieter'}</KartenTitel>
            <div className="flex flex-col">
              <DatenZeile label="Zahlungsart" wert={<Chip groesse="xs" ton={sepa ? 'ok' : 'neutral'}>{sepa ? 'Lastschrift aktiv' : 'Überweisung'}</Chip>} />
              <DatenZeile label="Fällig am" wert={m.miete_faellig_tag ? `${m.miete_faellig_tag}. des Monats` : ''} zahl />
              {m.mietintervall && <DatenZeile label="Intervall" wert={m.mietintervall} />}
              <DatenZeile label="IBAN" wert={ibanText(m.mieter_iban)} zahl />
              <DatenZeile label="Kontoinhaber" wert={(m.mieter_kontoinhaber ?? '').trim()} />
              {sepa && <DatenZeile label="Mandatsreferenz" wert={(m.sepa_mandatsreferenz ?? '').trim()} zahl />}
              {sepa && <DatenZeile label="Mandat vom" wert={m.sepa_mandatsdatum ? deDatum(m.sepa_mandatsdatum) : ''} zahl />}
            </div>
            <div className="flex items-center justify-between flex-wrap" style={{ gap: 10 }}>
              <ImmoButton icon={PencilSimple} onClick={() => s.bearbeiteMietverhaeltnis(m, 'miete')}>Im Mietverhältnis ändern</ImmoButton>
              <span style={{ fontSize: 12, color: 'var(--ink3)' }}>Bankabgleich: {BUCHHALTUNG_FOLGT}</span>
            </div>
          </InnenKarte>
        );
      })}
    </>
  );
}
